import type { ReadConfig } from 'api-read-hook';
import type { HydraCollection } from '../../types';

import { useApiRead } from 'api-read-hook';

export type V = {
  '@id': string;
  '@type': 'ClinicianAvailability';
  slot: string;
  duration: number;
};

export function useReadCollectionAvailabilitiesStartDateEndDate(
  id: string,
  startDate: string,
  endDate: string,
  options?: ReadConfig,
) {
  return useApiRead<HydraCollection<V>>(
    `/clinicians/${id}/availabilities/${startDate}/${endDate}`,
    options,
  );
}
